module.exports = __webpack_public_path__ + "img/cl_mobile_logo.55b6eeed.png";